"use client";
import { motion } from "framer-motion";

export function AnimatedText({
	text,
	className,
	triggerOnMount = false,
	delay = 0,
}: {
	text: string;
	className?: string;
	triggerOnMount?: boolean;
	delay?: number;
}) {
	const words = text.split(" ");

	const container = {
		hidden: { opacity: 0 },
		visible: {
			opacity: 1,
			transition: { staggerChildren: 0.08, delayChildren: delay },
		},
	};

	const child = {
		visible: {
			opacity: 1,
			y: 0,
			transition: {
				type: "spring" as const,
				damping: 12,
				stiffness: 100,
			},
		},
		hidden: {
			opacity: 0,
			y: 20,
			transition: {
				type: "spring" as const,
				damping: 12,
				stiffness: 100,
			},
		},
	};

	return (
		<motion.div
			style={{ overflow: "hidden", display: "flex", flexWrap: "wrap" }}
			variants={container}
			initial="hidden"
			animate={triggerOnMount ? "visible" : undefined}
			whileInView={!triggerOnMount ? "visible" : undefined}
			viewport={{ once: true }}
			className={className}
		>
			{words.map((word, index) => (
				<motion.span
					variants={child}
					style={{ marginRight: "0.2em" }}
					key={index}
				>
					{word}
				</motion.span>
			))}
		</motion.div>
	);
}
